import { render, staticRenderFns } from "./PromoPerson.vue?vue&type=template&id=cbae1626&"
import script from "./PromoPerson.vue?vue&type=script&lang=js&"
export * from "./PromoPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports